import { useEffect, useState } from "react";
import { BackpackScreen } from "./components/BackpackScreen";
import { CodingWorkshop } from "./components/CodingWorkshop";
import { Header } from "./components/Header";
import { LessonScreen } from "./components/LessonScreen";
import { WorldMap } from "./components/WorldMap";
import { worlds } from "./data/curriculum";
import { useProgress } from "./hooks/useProgress";
import type { World } from "./types";

type View = "map" | "lesson" | "coding" | "backpack";

function App() {
  const [view, setView] = useState<View>("map");
  const [activeWorld, setActiveWorld] = useState<World>(worlds[0]);
  const { progress, completeQuest, completeGate, loseHeart, refillHearts, reset } = useProgress();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [view]);

  function openWorld(world: World) {
    setActiveWorld(world);
    setView("lesson");
  }

  function wrongAttempt() {
    if (progress.hearts <= 1) {
      refillHearts();
      return;
    }
    loseHeart();
  }

  return (
    <div className="app-shell">
      {view !== "lesson" && view !== "coding" ? (
        <Header
          progress={progress}
          active={view === "backpack" ? "backpack" : "map"}
          onMap={() => setView("map")}
          onCoding={() => setView("coding")}
          onBackpack={() => setView("backpack")}
        />
      ) : null}

      {view === "map" ? (
        <WorldMap worlds={worlds} completed={progress.completedQuests} onOpenWorld={openWorld} onOpenCoding={() => setView("coding")} />
      ) : null}

      {view === "lesson" ? (
        <LessonScreen
          world={activeWorld}
          completed={progress.completedQuests}
          hearts={progress.hearts}
          onBack={() => setView("map")}
          onComplete={completeQuest}
          onWrong={wrongAttempt}
        />
      ) : null}

      {view === "coding" ? (
        <CodingWorkshop
          completed={progress.completedGates}
          hearts={progress.hearts}
          onBack={() => setView("map")}
          onComplete={completeGate}
          onWrong={wrongAttempt}
        />
      ) : null}

      {view === "backpack" ? (
        <BackpackScreen progress={progress} onBack={() => setView("map")} onReset={reset} />
      ) : null}
    </div>
  );
}

export default App;
